import styled from "@emotion/styled";
import { MDSText } from "@/mds";

export const SmartNoteRowWrapper = styled.div`
  position: relative;
`;

export const NoteRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing["2"]};
  min-height: 32px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.background};

  background-color: ${({ theme }) => theme.colors.background.button.transparent.default};

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.button.transparent.hover};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.background.button.transparent.hover};
  }
`;

export const LeadingIcon = styled.div<{ $isDoubleRow: boolean }>`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: ${({ $isDoubleRow }) => ($isDoubleRow ? "2px" : "-1px")};
  margin-right: -2px;
`;

export const NoteContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
`;

export const NoteTitle = styled(MDSText)`
  white-space: nowrap;
`;

export const NoteSubtitle = styled(MDSText)``;
